/**
 * FormLeaveConfirmDialog
 * Dolu bir form sayfasından (fatura/teklif/sipariş/irsaliye) ayrılmadan önce
 * gösterilen onay penceresi. Veriler otomatik taslakta saklandığı için
 * kullanıcıya geri yükleyebileceği bilgisi verilir.
 */

import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import HistoryIcon from '@mui/icons-material/History';

interface FormLeaveConfirmDialogProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const FormLeaveConfirmDialog: React.FC<FormLeaveConfirmDialogProps> = ({ open, onCancel, onConfirm }) => (
  <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth PaperProps={{ sx: { borderRadius: '12px' } }}>
    <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1, pb: 1 }}>
      <WarningAmberIcon color="warning" />
      Sayfadan Ayrılıyorsunuz
    </DialogTitle>
    <DialogContent>
      <Typography variant="body2" color="text.secondary">
        Form sayfasından ayrılmak üzeresiniz.
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, mt: 1.5, p: 1.5, bgcolor: 'action.hover', borderRadius: 1 }}>
        <HistoryIcon fontSize="small" color="action" sx={{ mt: 0.2 }} />
        <Typography variant="body2" color="text.secondary">
          Girilen bilgiler taslak olarak kaydedildi; forma döndüğünüzde geri yükleyebilirsiniz.
        </Typography>
      </Box>
    </DialogContent>
    <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
      <Button onClick={onCancel} variant="outlined" color="inherit">
        Formda Kal
      </Button>
      <Button onClick={onConfirm} variant="contained" color="warning" autoFocus>
        Ayrıl
      </Button>
    </DialogActions>
  </Dialog>
);

export default FormLeaveConfirmDialog;
